import { successSnackbar } from "lib/snackbar/success-snackbar"
import { infoSnackbar } from "lib/snackbar/info-snackbar"
import { warningSnackbar } from "lib/snackbar/warning-snackbar"

export function migrationResultSnackbar({ imported = 0, skipped = 0, alreadyRunning = false } = {}, noun) {
    if (alreadyRunning) {
        alreadyRunningSnackbar()
        return
    }
    if (imported === 0) {
        infoSnackbar(`Nothing migrated, the selected ${noun}s had already been migrated`)
        return
    }
    const skippedText = skipped > 0 ? `, ${skipped} had already been migrated and were skipped` : ""
    successSnackbar(`${imported} ${imported === 1 ? noun : `${noun}s`} migrated${skippedText}`)
}

export function alreadyRunningSnackbar() {
    warningSnackbar(
        "Another migration, import, backup or restore is already running for this client. Try again once it has finished"
    )
}
